export const POST_LAUREATLAPP_RETURN = 'POST_LAUREATLAPP_RETURN';
export const POST_LAUREATLAPP_SAGAS = 'POST_LAUREATLAPP_SAGAS';

export const GET_LAUREATLAPPS_RETURN = 'GET_LAUREATLAPPS_RETURN';
export const GET_LAUREATLAPPS_SAGAS = 'GET_LAUREATLAPPS_SAGAS';

export const GET_LAUREATLAPP_RETURN = 'GET_LAUREATLAPP_RETURN';
export const GET_LAUREATLAPP_SAGAS = 'GET_LAUREATLAPP_SAGAS';

export const PUT_LAUREATLAPP_RETURN = 'PUT_LAUREATLAPP_RETURN';
export const PUT_LAUREATLAPP_SAGAS = 'PUT_LAUREATLAPP_SAGAS';

export const DEL_LAUREATLAPP_RETURN = 'DEL_LAUREATLAPP_RETURN';
export const DEL_LAUREATLAPP_SAGAS = 'DEL_LAUREATLAPP_SAGAS';

// POST LAUREAT (LAPP)
export const postLaureatLappSagas = (xAccess, data) => ({
	type: POST_LAUREATLAPP_SAGAS,
	token: xAccess,
	data: data
});
export const postLaureatLappReturn = (result) => ({
	type: POST_LAUREATLAPP_RETURN,
	payload: result
});

// GET LAUREATS (LAPP)
export const getLaureatLappsSagas = (xAccess) => ({
	type: GET_LAUREATLAPPS_SAGAS,
	token: xAccess
});
export const getLaureatLappsReturn = (result) => ({
	type: GET_LAUREATLAPPS_RETURN,
	payload: result
});

// GET LAUREAT (LAPP)
export const getLaureatLappSagas = (uuid, xAccess) => ({
	type: GET_LAUREATLAPP_SAGAS,
	token: xAccess,
	payload: uuid
});
export const getLaureatLappReturn = (result) => ({
	type: GET_LAUREATLAPP_RETURN,
	payload: result
});

// PUT LAUREAT (LAPP)
export const putLaureatLappSagas = (uuid, xAccess, data) => ({
	type: PUT_LAUREATLAPP_SAGAS,
	token: xAccess,
	payload: uuid,
	data: data
});
export const putLaureatLappReturn = (result) => ({
	type: PUT_LAUREATLAPP_RETURN,
	payload: result
});

// DELETE LAUREAT (LAPP)
export const deleteLaureatLappSagas = (uuid, xAccess) => ({
	type: DEL_LAUREATLAPP_SAGAS,
	token: xAccess,
	payload: uuid
});
export const deleteLaureatLappReturn = (result) => ({
	type: DEL_LAUREATLAPP_RETURN,
	payload: result
});
